import { render, staticRenderFns } from "./EditStoragePlace.vue?vue&type=template&id=4393972e"
import script from "./EditStoragePlace.vue?vue&type=script&lang=js"
export * from "./EditStoragePlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports